import { render, staticRenderFns } from "./FinancialPendencies.vue?vue&type=template&id=40985440"
import script from "./FinancialPendencies.vue?vue&type=script&lang=js"
export * from "./FinancialPendencies.vue?vue&type=script&lang=js"
import style0 from "./FinancialPendencies.vue?vue&type=style&index=0&id=40985440&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports